import isProd from '../constants/isProd'

const notepadParts = isProd ? window.notepad_parts_by_hash : []

export default notepadParts
